import { Typography, Card, Box, Divider, Link, useMediaQuery, Theme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecordContext } from "react-admin";
import AnimatedBlock from "../../../components/Common/AnimatedBlock";
import InfoRow from "../../../components/Common/InfoRow";
import { StatusLabel } from "../../../components/Label/status";
import { explorerTxUrl, formatCrypto, formatDateTime, networkLabel } from "../../../utils/paymentFormat";
import { ProjectField } from "../ProjectField";

const Mono = ({ children }: { children: any }) => (
  <Typography component="span" sx={{ fontFamily: "monospace", fontSize: 13, fontWeight: 400 }}>
    {children}
  </Typography>
);

function InfoTransferTab() {
  const { t }: { t: any } = useTranslation();
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down("sm"));
  const record = useRecordContext();
  if (!record) return null;

  const explorer = explorerTxUrl(record.currency, record.tx_hash);
  return (
    <Box>
      {!isMobile && (
        <Box pb={2}>
          <Typography variant="h6">
            {t("Summary")}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t("Amount, destination and status of this transfer.")}
          </Typography>
        </Box>
      )}

      <AnimatedBlock>
        <Card>
          <Box px={2} pt={2.5} pb={1.5}>
            <Typography variant="h5" fontWeight="bold">
              {t("Transfer")}
            </Typography>
          </Box>
          <Divider />
          <Box px={2} py={1}>
            <InfoRow label={t("Reference")}>{record.internalRef || "—"}</InfoRow>
            <InfoRow label={t("Status")}>
              <StatusLabel statusField="statusOrder" />
            </InfoRow>
            <InfoRow label={t("Amount")}>
              {formatCrypto(record.amount)} {record.currency}
            </InfoRow>
            <InfoRow label={t("Entity")}>
              <Box component="span" sx={{ "& .MuiTypography-root": { fontWeight: 700 } }}>
                <ProjectField />
              </Box>
            </InfoRow>
            <InfoRow label={t("Network")}>{networkLabel(record.network) || record.blockchain || "—"}</InfoRow>
            <InfoRow label={t("Destination address")}>{record.address ? <Mono>{record.address}</Mono> : "—"}</InfoRow>
            <InfoRow label={t("Tx hash")}>
              {record.tx_hash ? (
                explorer ? (
                  <Link href={explorer} target="_blank" rel="noopener noreferrer">
                    <Mono>{record.tx_hash}</Mono>
                  </Link>
                ) : (
                  <Mono>{record.tx_hash}</Mono>
                )
              ) : (
                "—"
              )}
            </InfoRow>
            <InfoRow label={t("Billing month")}>{record.billingMonth || "—"}</InfoRow>
            <InfoRow label={t("Created date")}>{formatDateTime(record.dateCreated)}</InfoRow>
            <InfoRow label={t("ID")}>
              <Mono>{record.id}</Mono>
            </InfoRow>
          </Box>
        </Card>
      </AnimatedBlock>
    </Box>
  );
}

export default InfoTransferTab;
